import { render, staticRenderFns } from "./ListaRilevazioniDettagliata.vue?vue&type=template&id=3c7dc541&"
import script from "./ListaRilevazioniDettagliata.vue?vue&type=script&lang=js&"
export * from "./ListaRilevazioniDettagliata.vue?vue&type=script&lang=js&"
import style0 from "./ListaRilevazioniDettagliata.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports